// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".links[data-v-9f8e2424],form#login[data-v-9f8e2424]{margin-top:20px}.links[data-v-9f8e2424]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
